<template>
    <div class="booking-slide">
        <h3 class="w-full font-sans font-medium text-center text-blue-500 h2">
            {{ ui.selection.heading }}
        </h3>

        <transition name="slide" mode="out-in">
            <!-- <div v-if="appointments.length === 0" class="pt-10 text-center text-blue-500">
                <p>We're sorry, there are currently no appointments available for this location.</p>
                <button class="mt-8 btn" @click="$emit('back')">Back</button>
            </div> -->

            <ChooseSearchMethod
                v-if="step === 0"
                :ui="ui"
                :preferred-date.sync="preferredDate"
                :preferred-time.sync="preferredTime"
                :preferred-practitioner-id.sync="preferredPractitionerId"
                :search-by.sync="searchBy"
                :practitioners="practitioners"
                :appointments="bookableAppointments"
                :service-type="serviceType"
                :is-loading="isLoading"
                :weekday="weekday"
                @update-weekday="$emit('update-weekday', $event)"
                @update-date-range="$emit('update-date-range', $event)"
                @update-practitioner="$emit('update-practitioner', preferredPractitionerId)"
                @next="next"
            />

            <component
                :is="'Search' + searchBy"
                v-else-if="step === 1"
                :practitioner-id.sync="preferredPractitionerId"
                :preferred-date.sync="preferredDate"
                :practitioners="practitioners"
                :appointments="bookableAppointments"
                :appointment-id="appointmentId"
                :service-type="serviceType"
                :weekday="weekday"
                :preferred-time="preferredTime"
                :is-loading="isLoading"
                @reset-date-range="$emit('update-date-range')"
                @reset-practitioner="$emit('update-practitioner', null)"
                @select-appointment="$emit('select-appointment', $event)"
                @back="back"
                @next="$emit('complete')"
            />
        </transition>
    </div>
</template>

<script>
import scrollTop from '@/../vue/online-booking/utils/scroll';
import ChooseSearchMethod from '@/../vue/online-booking/steps/selection/ChooseSearchMethod.vue';
import SearchByDay from '@/../vue/online-booking/steps/selection/SearchByDay.vue';
import SearchByPractitioner from '@/../vue/online-booking/steps/selection/SearchByPractitioner.vue';
import SearchByNextAvailable from '@/../vue/online-booking/steps/selection/SearchByNextAvailable.vue';
import appointmentFilters from '@/../vue/online-booking/mixins/appointment-filters';

export default {
    components: {
        ChooseSearchMethod,
        SearchByDay,
        SearchByPractitioner,
        SearchByNextAvailable
    },

    mixins: [appointmentFilters],

    props: {
        practitioners: {
            type: Array,
            required: true
        },
        serviceType: {
            type: String,
            required: true
        },
        appointments: {
            type: Array,
            required: true
        },
        appointmentId: {
            type: Number,
            default: null
        },
        weekday: {
            type: String,
            default: null
        },
        ui: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    },

    data: () => ({
        preferredPractitionerId: null,
        preferredDate: null,
        preferredTime: null,
        searchBy: null,
        step: 0
    }),

    watch: {
        searchBy() {
            this.clearState();
        }
    },

    methods: {
        next() {
            this.step++;
            scrollTop();
        },
        back() {
            this.searchBy = null;
            this.step = 0;
        },
        clearState() {
            this.$emit('select-appointment', null);
            this.$emit('update-practitioner', null);
            this.$emit('update-weekday', null);
            this.$emit('update-date-range', null);
            this.preferredDate = null;
            this.preferredTime = null;
            this.preferredPractitionerId = null;
        }
    }
};
</script>
